import { vModelText as _vModelText, withKeys as _withKeys, createVNode as _createVNode, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, renderList as _renderList, Fragment as _Fragment, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-2d60c421")

_pushScopeId("data-v-2d60c421")
const _hoisted_1 = { class: "w-full bg-white rounded-lg shadow-sm border border-gray-100 p-4" }
const _hoisted_2 = { class: "flex justify-between items-start gap-4 mb-6" }
const _hoisted_3 = { class: "flex w-1/2 flex-row" }
const _hoisted_4 = { class: "w-full relative" }
const _hoisted_5 = { class: "flex-none w-40 h-24 flex justify-center items-center relative overflow-hidden ml-4" }
const _hoisted_6 = { class: "flex items-center gap-2" }
const _hoisted_7 = {
  key: 0,
  class: "w-120 bg-white rounded-lg border border-gray-200 flex flex-col h-24 overflow-hidden shadow-sm"
}
const _hoisted_8 = { class: "flex justify-between items-center px-3 py-2 bg-gray-100 border-b border-gray-200" }
const _hoisted_9 = { class: "font-bold text-gray-800 text-xs" }
const _hoisted_10 = { class: "flex items-center gap-2" }
const _hoisted_11 = { class: "text-gray-800 text-xs font-bold" }
const _hoisted_12 = { class: "overflow-y-auto flex-1 custom-scrollbar" }
const _hoisted_13 = { class: "font-medium text-gray-700 mr-0.5" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_Icons = _resolveComponent("Icons")!
  const _component_ScanTableList = _resolveComponent("ScanTableList")!

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("div", _hoisted_3, [
        _createVNode("div", _hoisted_4, [
          _withDirectives(_createVNode("input", {
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.scanInput = $event)),
            ref: "scanInputRef",
            type: "text",
            placeholder: 
              _ctx.$t('cargoV2.components.scanTableSection.inputPlaceholder')
            ,
            class: "w-full h-24 pl-4 pr-12 border border-gray-300 rounded-lg focus:outline-none focus:border-primary-500 transition-colors",
            onKeydown: _cache[2] || (_cache[2] = _withKeys(
//@ts-ignore
(...args) => (_ctx.onScan && _ctx.onScan(...args)), ["enter"]))
          }, null, 40, ["placeholder"]), [
            [_vModelText, _ctx.scanInput]
          ])
        ]),
        _createVNode("div", _hoisted_5, [
          (_ctx.statusBadgeSrc)
            ? (_openBlock(), _createBlock("div", {
                key: _ctx.scanCounter,
                class: `flex flex-col items-center ${_ctx.statusAnimationClass}`
              }, [
                _createVNode("div", _hoisted_6, [
                  _createVNode("img", {
                    src: _ctx.statusBadgeSrc,
                    alt: _ctx.statusBadgeAlt,
                    class: "h-20 w-auto max-w-full"
                  }, null, 8, ["src", "alt"])
                ])
              ], 2))
            : _createCommentVNode("", true)
        ])
      ]),
      (_ctx.invalidSttList.length > 0)
        ? (_openBlock(), _createBlock("div", _hoisted_7, [
            _createVNode("div", _hoisted_8, [
              _createVNode("span", _hoisted_9, _toDisplayString(_ctx.$t("cargoV2.components.scanTableSection.invalidSttTitle")), 1),
              _createVNode("div", _hoisted_10, [
                _createVNode("span", _hoisted_11, _toDisplayString(_ctx.$t("cargoV2.components.scanTableSection.total", {
                count: _ctx.invalidSttList.length
              })), 1),
                _createVNode(_component_Icons, {
                  name: "download-new",
                  class: "w-4 h-4 text-red-500 cursor-pointer hover:text-red-700",
                  onClick: _ctx.downloadInvalidSttList
                }, null, 8, ["onClick"])
              ])
            ]),
            _createVNode("div", _hoisted_12, [
              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.invalidSttList, (item, idx) => {
                return (_openBlock(), _createBlock("div", {
                  key: idx,
                  class: "flex justify-between items-center px-3 py-2 border-b border-gray-100 last:border-0 text-xs hover:bg-gray-50 transition-colors"
                }, [
                  _createVNode("span", _hoisted_13, _toDisplayString(item.sttNumber), 1),
                  _createVNode("span", {
                    class: "text-gray-500 truncate max-w-[140px]",
                    title: item.reason
                  }, _toDisplayString(item.reason), 9, ["title"])
                ]))
              }), 128))
            ])
          ]))
        : _createCommentVNode("", true)
    ]),
    _createVNode(_component_ScanTableList, {
      items: _ctx.form.bagOrStt,
      onDelete: _ctx.onDelete
    }, null, 8, ["items", "onDelete"])
  ]))
})